import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { CuestionariosRoutingModule } from './cuestionarios-routing.module';
import { AsignacionComponent } from './asignacion/asignacion.component';
import { SharedModule } from '../../shared/shared.module';
import { CuestionariosAsignadosComponent } from './cuestionarios-asignados/cuestionarios-asignados.component';
import { MatTableModule } from '@angular/material/table';
import { QuestionsComponent } from './funciones/questions/questions.component';
import { Cuestionariov2Component } from './cuestionariov2/cuestionariov2.component';
import { RecaptchaFormsModule, RecaptchaModule } from 'ng-recaptcha';


@NgModule({
  declarations: [
    AsignacionComponent,
    CuestionariosAsignadosComponent,
    QuestionsComponent,
    Cuestionariov2Component
  ],
  imports: [
    CommonModule,
    CuestionariosRoutingModule,
    SharedModule,
    RecaptchaModule,
    RecaptchaFormsModule,
    
  ]
})
export class CuestionariosModule { }
